import ProgressBar from "progressbar.js";
/* Import for threat detection is commented as of SEO-2860.
 * It should be uncommented once a new design for the section is ready (SEO-2862, most likely).
 */
import threatDetection from "./threat-detection.js";
import reportCommentModal from "./report-comment-modal.js";

(function ($, window, document) {
  $(function () {
    $('input[name="comment_key"]').each(function () {
      $(this).val("no bots");
    });

    var $leaveCommentBtn = $("#leave-comment-btn");
    var $leaveCommentWrapper = $("#leave-a-comment-wrapper");
    var $leaveCommentChevron = $(".leave-comment-chevron");
    var $leaveCommentWrapperBottom = $("#leave-a-comment-wrapper-bottom");

    $leaveCommentBtn.on("click", function () {
      console.log("clicked");
      var $target = $leaveCommentWrapperBottom;
      $.smoothScroll({
        scrollTarget: $target,
        offset: -($("nav.navbar").outerHeight() + 10),
        easing: "swing",
        speed: 1000,
        afterScroll: function () {
          $target.find("textarea[name=comment]").focus();
        },
      });
    });

    $(".comment-form-wrapper form").each(function () {
      var icon =
        ' <span class="glyphicon glyphicon-triangle-top"></span> &nbsp;';

      $(this).validate({
        ignore: ".ignore",
        rules: {
          comment: {
            minlength: 3,
            maxlength: 400,
            required: true,
          },
          contact_type: {
            required: true,
          },
          hiddenRecaptcha: {
            required: function () {
              if (grecaptcha.getResponse(widgetId) == "") {
                return true;
              } else {
                return false;
              }
            },
          },
        },
        messages: {
          comment: icon + "Please enter your comment",
          contact_type: icon + "Please select a call type",
          hiddenRecaptcha: icon + "Please check the box",
        },
        highlight: function (element) {
          $(element).closest(".form-group").addClass("has-error");
        },
        unhighlight: function (element) {
          $(element).closest(".form-group").removeClass("has-error");
        },
        errorElement: "span",
        errorClass: "help-block",
        errorPlacement: function (error, element) {
          if (element.parent(".input-group").length) {
            error.insertAfter(element.parent());
          } else {
            error.insertAfter(element);
          }
        },
      });
    });

    $(".btn-radio-spammer").on("click", function () {
      $(this).children("input[name=spammer]").first().prop("checked", true);

      var resp = $(this).children("input[name=spammer]").first().val();
      var isSpammer = resp.toLowerCase().substring(resp.indexOf("-") + 1);
      var phTextObj = {
        yes: "Tell everyone about this SPAMMER here.",
        no: "This caller is not a spammer -- feel free to leave a comment here.",
        unknown:
          "Share as much info as you can about " +
          PHONE_NUMBER +
          " for everyone's benefit.",
      };
      var phText = "";
      switch (isSpammer) {
        case "yes":
          phText = phTextObj.yes;
          tagIt("spammer", "Yes");
          break;
        case "no":
          phText = phTextObj.no;
          tagIt("spammer", "No");
          break;
        case "unknown":
          phText = phTextObj.unknown;
          tagIt("spammer", "Unknown");
          break;
      }

      $(this)
        .closest("form")
        .find("textarea[name=comment]")
        .attr("placeholder", phText);
    });

    var tagIt = function (tag, tag_value) {
      var tag_data = {};
      tag_data[tag] = tag_value;
    };

    $("#spam-question a.btn:not(.btn-report)").on("click", function (e) {
      e.preventDefault();

      var resp = $(this).attr("id");
      var spammerInput = "input[name=spammer]";
      var $target = $leaveCommentWrapperBottom;

      if ($leaveCommentBtn.length) {
        $leaveCommentWrapper.slideToggle();
        $leaveCommentChevron.toggleClass(
          "glyphicon-chevron-down glyphicon-chevron-up",
        );
      }

      $.smoothScroll({
        scrollTarget: $target,
        offset: -($("nav.navbar").outerHeight() + 10),
        easing: "swing",
        speed: 1000,
        beforeScroll: function () {
          // SELECT
          // $target.find(spammerInput).filter(function(i, e) {
          //   return $(e).text().toLowerCase() == resp.substring(resp.indexOf("-") + 1);
          // }).prop('selected', true);

          // RADIO
          var $selected = $target.find(spammerInput).filter(function (i, e) {
            return (
              $(e).val().toLowerCase() == resp.substring(resp.indexOf("-") + 1)
            );
          });
          $selected.parent("label").trigger("click");
        },
        afterScroll: function () {
          $target.find("textarea[name=comment]").focus();
        },
      });
    });

    // Hack to fix affix in Safari
    if (
      $(window).height() >
      $("nav.navbar").outerHeight(true) + $("#info-widget").outerHeight(true)
    ) {
      var widget = $("#info-widget");
      widget.affix({
        offset: {
          top: function () {
            return (this.top = $("nav.navbar").outerHeight(true));
          },
          bottom: function () {
            return (this.bottom = $("footer").outerHeight(true));
          },
        },
      });

      if (
        navigator.userAgent.indexOf("Safari") != -1 &&
        navigator.userAgent.indexOf("Chrome") == -1
      ) {
        var explicitlySetAffixPosition = function () {
          widget.css("left", widget.offset().left + "px");
        };
        var resetLeftPosition = function () {
          /* Adapt the left property to your element's value before any affix behavior */
          widget.css("left", "0px");
        };
        /* Before the element becomes affixed, add left CSS that is equal to the distance of the element from the left of the screen */
        widget.on("affix.bs.affix", function () {
          explicitlySetAffixPosition();
        });
        /* Before the element becomes affix-bottom, reset the CSS left property to as it was before */
        widget.on("affix-bottom.bs.affix", function () {
          resetLeftPosition();
        });
        /* Do the same for affix-top */
        widget.on("affix-top.bs.affix", function () {
          resetLeftPosition();
        });

        /* On resize of window, un-affix affixed widget to measure where it should be located, set the left CSS accordingly, re-affix it */
        $(window).resize(function () {
          if (widget.hasClass("affix")) {
            widget.removeClass("affix");
            explicitlySetAffixPosition();
            widget.addClass("affix");
          } else if (widget.hasClass("affix-bottom")) {
            resetLeftPosition();
          }
        });
      }
    }

    $(".sp-container").each(function () {
      var splink = $(this).data("href");
      $(this).load(splink, function () {
        $(this)
          .find(".sp-link")
          .on("click", function () {
            var url = $(this).data("href");
            var splink = $(this).data("splink");
            if (typeof splink !== "undefined") {
              var params = { splink: splink };
              url += "?" + $.param(params);
            }
            $(this).data("target") == "_blank"
              ? window.open(url, "_blank")
              : (document.location.href = url);
          });
      });
    });

    // Circles
    var progressBarTriggered = false;
    if ($("#circles-1").length) {
      if (!progressBarTriggered) {
        var scrollTop = $(window).scrollTop(),
          windowHeight = $(window).height(),
          elem = $("#circles-1").offset().top,
          final = elem - windowHeight,
          distance = final - scrollTop;
        if (distance < 0) {
          $(".scoreboard-number").css("border-color", "#cccccc");
          var startColorDefault = "#6FD57F";
          var endColorDefault = "#f1c100";

          $('[id^="circles-"]').each(function () {
            $(this).text("");
            var startColor =
              $(this).data("circle-color-start") || startColorDefault;
            var endColor = $(this).data("circle-color-end") || endColorDefault;
            var colorText = $(this).data("circle-color-text") || false;
            var suffix = $(this).data("circle-suffix");
            var val = $(this).data("circle-val") || 0;
            var max = $(this).data("circle-max") || 1;

            var circle = new ProgressBar.Circle("#" + $(this).attr("id"), {
              color: startColor,
              strokeWidth: 3,
              trailColor: "#eee",
              trailWidth: 3,
              trailDash: "4,2",
              duration: 6000,
              easing: "easeOutQuart",
              text: {
                autoStyleContainer: false,
              },
              from: {
                color: startColor,
                width: 1,
              },
              to: {
                color: endColor,
                width: 3,
              },
              step: function (state, circle) {
                circle.setText(
                  Math.abs((circle.value() * max).toFixed(0)).toString() +
                    suffix,
                );
                circle.path.setAttribute("stroke", state.color);
                circle.path.setAttribute("stroke-width", state.width);

                if (colorText) {
                  $(circle.text).css("color", state.color);
                }
              },
            });

            circle.animate(val / max);
          });

          progressBarTriggered = true;
        }
      }
    }

    // Add scroll event listener for circles animation
    $(window).on("scroll", function () {
      if ($("#circles-1").length && !progressBarTriggered) {
        var scrollTop = $(window).scrollTop(),
          windowHeight = $(window).height(),
          elem = $("#circles-1").offset().top,
          final = elem - windowHeight,
          distance = final - scrollTop;

        if (distance < 0) {
          $(".scoreboard-number").css("border-color", "#cccccc");
          var startColorDefault = "#6FD57F";
          var endColorDefault = "#f1c100";

          $('[id^="circles-"]').each(function () {
            $(this).text("");
            var startColor =
              $(this).data("circle-color-start") || startColorDefault;
            var endColor = $(this).data("circle-color-end") || endColorDefault;
            var colorText = $(this).data("circle-color-text") || false;
            var suffix = $(this).data("circle-suffix");
            var val = $(this).data("circle-val") || 0;
            var max = $(this).data("circle-max") || 1;

            var circle = new ProgressBar.Circle("#" + $(this).attr("id"), {
              color: startColor,
              strokeWidth: 3,
              trailColor: "#eee",
              trailWidth: 3,
              trailDash: "4,2",
              duration: 6000,
              easing: "easeOutQuart",
              text: {
                autoStyleContainer: false,
              },
              from: {
                color: startColor,
                width: 1,
              },
              to: {
                color: endColor,
                width: 3,
              },
              step: function (state, circle) {
                circle.setText(
                  Math.abs((circle.value() * max).toFixed(0)).toString() +
                    suffix,
                );
                circle.path.setAttribute("stroke", state.color);
                circle.path.setAttribute("stroke-width", state.width);

                if (colorText) {
                  $(circle.text).css("color", state.color);
                }
              },
            });

            circle.animate(val / max);
          });

          progressBarTriggered = true;
        }
      }
    });

    document.querySelectorAll(".btn-comment-options").forEach((button) => {
      button.addEventListener("click", function (e) {
        e.stopPropagation();
        const commentActions = this.closest(".comment-actions");
        const reportButton = commentActions.querySelector(
          ".report-comment-link",
        );
        const isVisible = reportButton.classList.contains("show");

        document
          .querySelectorAll(".report-comment-link.show")
          .forEach((btn) => {
            btn.classList.remove("show");
          });

        if (!isVisible) {
          reportButton.classList.add("show");
        }
      });
    });

    document.addEventListener("click", function () {
      document.querySelectorAll(".report-comment-link.show").forEach((btn) => {
        btn.classList.remove("show");
      });
    });

    // Report comment modal — 3-step wizard
    reportCommentModal();

    if (
      window.location.hash &&
      window.location.hash.indexOf("#comment-") === 0
    ) {
      var $commentTarget = $(window.location.hash);

      if ($commentTarget.length) {
        $.smoothScroll({
          scrollTarget: $commentTarget,
          offset: -($("nav.navbar").outerHeight() + 10),
          easing: "swing",
          speed: 800,
        });
      }
    }

    // Threat Detection Animations on scroll
    threatDetection();
  });
})(jQuery, window, document);
